import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { QueryCache, ReactQueryCacheProvider } from 'react-query';
import { ThemeProvider } from 'styled-components';
import theme from 'theme';
import 'normalize.css';
import { Provider } from 'react-redux';
import store from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import printEnvVars from './utils/print-env-vars';

const queryCache = new QueryCache();

printEnvVars();

ReactDOM.render(
    <Provider store={store.store}>
        <PersistGate loading={'Loading'} persistor={store.persistor}>
            <ThemeProvider theme={theme}>
                <ReactQueryCacheProvider queryCache={queryCache}>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </ReactQueryCacheProvider>
            </ThemeProvider>
        </PersistGate>
    </Provider>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
